<template>
    <multiselect
        v-model="feeAgreement"
        :options="agreements"
        track-by="uuid"
        label="name"
        :multiple="false"
        :allowEmpty="!!allowEmpty"
        placeholder="Convenio de cuota"
        selectedLabel=""
        selectLabel=""
        deselectLabel=""
        @input="notifyChange"></multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {mapGetters} from 'vuex';

    export default {
        name: "FeeAgreementSelector",
        components: {
            Multiselect
        },
        props: {
            value: Object,
            allowEmpty: Boolean,
            headquartersId: String
        },
        data: function () {
            return {
                feeAgreement: null
            }
        },
        created() {
            this.$store.dispatch('loadAgreements');
            this.feeAgreement = this.evaluateValue(this.value);
        },
        computed: {
            ...mapGetters([
                'feeAgreements',
                'feeAgreementsByHeadquarters'
            ]),
            agreements() {
                if (!!this.headquartersId) {
                    return this.feeAgreementsByHeadquarters(this.headquartersId);
                } else {
                    return this.feeAgreements
                }
            }
        },
        methods: {
            evaluateValue(value) {
                if (!!value && !!value.uuid) {
                    return this.findAgreementByUuid(value.uuid);
                } else {
                    return null;
                }
            },
            findAgreementByUuid(uuid) {
                if (!!this.headquartersId) {
                    return this.feeAgreementsByHeadquarters(this.headquartersId).find(agreement => (agreement.uuid === uuid));
                } else {
                    return this.feeAgreements.find(agreement => (agreement.uuid === uuid));
                }
            },
            notifyChange(agreement) {
                this.$emit('input', agreement);
            }
        },
        watch: {
            value: function () {
                this.feeAgreement = this.evaluateValue(this.value);
            },
            feeAgreements: function () {
                this.feeAgreement = this.evaluateValue(this.value);
            },
            headquartersId: function () {
                this.feeAgreement = this.evaluateValue(this.value);
            }
        }
    }
</script>

<style scoped>

</style>